import { render, staticRenderFns } from "./ActionContactRequest.vue?vue&type=template&id=cc0555c2&"
import script from "./ActionContactRequest.vue?vue&type=script&lang=js&"
export * from "./ActionContactRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports